module.exports = __webpack_public_path__ + "static/16.3_Early_Middle_Ages-c09ec8708a7ac9d439ffc732ae8ca6bc.pdf";